import React from 'react';
import ReactDOM from 'react-dom/client';
import AppWithAnimation from './AppWithAnimation';
import './index.css';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
    <React.StrictMode>
        <AppWithAnimation />
    </React.StrictMode>
);
